import ProfileTopNavigation from './ProfileTopNavigation';
import PersonalDetailsSection from '../../PageComponent/ProfilePage/PersonalDetailsSection';

function PersonalDetails() {
  return (
    <div className="text-coalBlack">
      <ProfileTopNavigation pageTitle={'Personal Details'} />
      <PersonalDetailsSection />
    </div>
  );
}

export default PersonalDetails;
